import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("kbl_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Global 401 handler. When the admin JWT expires (default 7 days), any API
// call — including the autopilot status poller running in the background —
// starts returning 401. Without this interceptor, callers alert the raw
// "Token expired" backend message from arbitrary places (e.g. mid-polling on
// mobile), which is confusing. Instead we clear the stale token exactly once,
// send the user to /admin/login, and reject the promise silently so no
// downstream alert fires.
let _redirectingOn401 = false;
api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;
        const detail = error?.response?.data?.detail || "";
        const isAuthExpired = status === 401 && /token|not authenticated/i.test(detail);
        if (isAuthExpired && !_redirectingOn401) {
            _redirectingOn401 = true;
            localStorage.removeItem("kbl_token");
            // Only redirect if we're actually inside the admin area — public
            // 401s (shouldn't happen but safety) don't need a login redirect.
            if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) {
                // Small delay so React finishes any current render pass first.
                setTimeout(() => {
                    window.location.href = "/admin/login?expired=1";
                }, 50);
            }
            // Swallow the error so callers don't alert "Token expired".
            return new Promise(() => {});
        }
        return Promise.reject(error);
    },
);

export default api;
